<template>
  <div class="winDialog">
    <el-dialog :title="dialog.title" :visible.sync="dialog.dialogVisible" width="80%" top="12" class="exhibition-dialog" @close="diaClose">
      <div class="dialog">
        <div class="tabs dn-content-bg" v-if="tabsShow">
          <el-button :type="dialog.btnIndex == index ? 'primary' : 'info'" :plain="dialog.btnIndex == index ? false : true" size="small" v-for="(item,index) in dialog.ids.items" :key="index" @click="tabsBtn(index,item)">{{item.name}}</el-button>
        </div>
        <div :class="['header1',dialog.alarmInfo?'alarmInfo':'']">
          <div class="header-list" style="width: 330px">
            <div class="header-item dn-content-bg" v-if="runningState">
              <ele-detail :obj="runningState"></ele-detail>
            </div>
          </div>
          <div class="header-list" style="width: 340px" v-if="dialog.alarmInfo">
            <div class="header-item first dn-content-bg">
              <alarm-info name="设备状态" :alarmInfo="dialog.alarmInfo" :ids="dialog.ids"></alarm-info>
            </div>
          </div>
          <div class="header-list" style="width: calc(100% - 670px);">
            <div class="header-item first dn-content-bg">
              <real-time name="实时数值" :realInfo="newEchartsData" :dialog="dialog"></real-time>
            </div>
          </div>
        </div>
        <div class="line-list">
          <div class="line-item" v-for="(item,index) in wsItemData" :key="item.name">
            <dialog-echarts :obj="item" :realIndex="index === realIndex" :websocketData="websocketData" :timeData="timeData[index]" :analysisUrl="analysisUrl" @updateData="updateData"></dialog-echarts>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import EleDataChart from './EleDataChart'
import handleData from '@/utils/handleData.js'
import EleDetail from './EleDetail'
import EleState from './EleState'
import EleTemperature from './EleTemperature'
import DialogEcharts from './DialogEcharts'
import EleDataResult from './EleDataResult'
import AlarmInfo from './AlarmInfo'
import RealTime from './RealTime'
import api from '@common/api/index.js'
let { wsLoginState, wsRegisterNode, wsSetNodeSucc, wsSuccState, wsMsgSatet } = {
  wsLoginState: '101',
  wsRegisterNode: '102',
  wsSetNodeSucc: '103',
  wsSuccState: '104',
  wsMsgSatet: '105',
}
/* 
wsLoginState:登录websocket状态码        wsRegisterNode:注册计量点状态码         wsSetNodeSucc:注册计量点实施状态码
wsSuccState:计量点注册成功状态码         wsMsgSatet:接收信息状态码
*/
export default {
  name: 'WinDialog',
  props: {
    dialog: {
      type: Object,
      default: () => {
        return {
          title: '', //弹窗标题
          btnIndex: 0, //当前按钮的选中
          dialogVisible: false, //弹窗显示状态
        }
      },
    },
  },
  components: {
    EleDataChart,
    EleDetail,
    EleState,
    EleTemperature,
    DialogEcharts,
    EleDataResult,
    AlarmInfo,
    RealTime,
  },
  data () {
    return {
      runningState: null,
      tabsShow: false, //是否显示标签页
      color: ['#d4431c', '#0e9ef1', '#f3b84c', '#1db7a2'],
      wsItemData: [], //轮训个数
      time: null,
      timeData: [], //最近半小时的数据
      websocketData: {}, //websocket返回的数据
      minMaxValuesVoltage: {
        min: 0,
        max: 400,
      },
      minMaxValuesCurrent: {
        min: 0,
        max: 400,
      },
      codes: [],
      realIndex: -1, //接收实时数据点击的索引
      newEchartsData: [], //最新的echarts数据
      analysisUrl: '', //跳转到运行分析的url
    }
  },
  mounted () {
    this.$once('hook:beforeDestroy', () => {
      //界面关闭的时候，关闭websock
      this.socket_ && this.socket_.close()
      this.time && clearTimeout(this.time)
    })
    this.bus.$off('itemClick')
    this.bus.$on('itemClick', (e) => {
      this.realIndex = e
    })
  },
  methods: {
    async func () {
      /* 恢复默认 */
      this.socket_ && this.socket_.close()
      this.time && clearTimeout(this.time)
      this.timeData = []
      this.wsItemData = []
      this.runningState = null
      this.websocketData = {}
        ; (this.minMaxValuesVoltage = {
          min: 0,
          max: 400,
        }),
          (this.minMaxValuesCurrent = {
            min: 0,
            max: 400,
          })
      this.codes = []
      this.realIndex = -1 //接收实时数据点击的索引
      this.newEchartsData = [] //最新的echarts数据
      /* 恢复默认 */
      //参数判断
      if (this.dialog.ids.length === 0) {
        //如果传递过来的id是空的
        //此情况有误，需判断
        this.tabsShow = false
      } else if (this.dialog.ids.length === 1) {
        //只有一个参数的情况下
        //不是容器的情况下，或者容器下只有一个计量点，此时需要隐藏tabs
        this.tabsShow = false
        await this.getRunningState(this.dialog.ids[0])
        await this.getMeasureProperty(this.dialog.ids[0])
        this.getMeasuresInfo(this.dialog.ids[0]) //通过计量点查询模板信息
      } else {
        //多个计量点的情况
        await this.getRunningState(this.dialog.ids.items[this.dialog.btnIndex])
        await this.getMeasureProperty(
          this.dialog.ids.items[this.dialog.btnIndex]
        )
        this.getItemNum(this.dialog.ids.items[this.dialog.btnIndex])
        this.tabsShow = true
      }
    },
    async getRunningState (item) {
      let vm = this
      let res = await api.tmp.getRunningState(item.id || item)
      if (res) {
        this.runningState = res.data
        if (this.dialog.ids.items) {
          if (
            res.data.messageJson.name ==
            this.dialog.ids.items[this.dialog.btnIndex].name
          ) {
            this.time && clearTimeout(this.time)
            this.time = setTimeout(() => {
              vm.getRunningState(item)
            }, 30 * 1000)
          }
        } else {
          this.time && clearTimeout(this.time)
          this.time = setTimeout(() => {
            vm.getRunningState(item)
          }, 30 * 1000)
        }
      }
    },
    //获取最大最小值
    async getMeasureProperty (item) {
      let res = await api.measure.getMeasureProperty(item.id || item, '')
      let arrVoltage = []
      let arrCurrent = []
      if (res) {
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].name === 'analysisUrl') {
            //查找跳转运行分析的url地址
            this.analysisUrl = res.data[i].value
          }
          if (res.data[i].name.indexOf('benchmarking') > -1) {
            let name = res.data[i].name
            let code =
              name.indexOf('benchmarkingMin') > -1
                ? name.replace('benchmarkingMin', '')
                : name.replace('benchmarkingMax', '')
            let voltage = handleData.setCodes('voltage', '') //电压
            let current = handleData.setCodes('current', '') //电流
            const voltageIndex = voltage.findIndex((obj) => obj.code == code)
            const currentIndex = current.findIndex((obj) => obj.code == code)
            if (voltageIndex > -1) {
              arrVoltage.push({
                label: res.data[i].displayName,
                value: res.data[i].value,
                type: name.indexOf('benchmarkingMin') > -1 ? 'bottom' : 'top',
              })
            }
            if (currentIndex > -1) {
              arrCurrent.push({
                label: res.data[i].displayName,
                value: res.data[i].value,
                dataType:
                  name.indexOf('benchmarkingMin') > -1 ? 'bottom' : 'top',
              })
            }
          }
        }
        if (arrVoltage.length > 0) {
          //电压
          this.minMaxValuesVoltage = {
            min: arrVoltage.sort((a, b) => {
              return Number(a.value) - Number(b.value)
            })[0].value,
            max: arrVoltage.sort((a, b) => {
              return Number(a.value) - Number(b.value)
            })[arrVoltage.length - 1].value,
          }
        } else {
          this.minMaxValuesVoltage = {
            min: 0,
            max: 400,
          }
        }
        if (arrCurrent.length > 0) {
          //电流
          this.minMaxValuesCurrent = {
            min: 0,
            // min:arrCurrent.sort((a, b) => { return Number(a.value) -Number(b.value) })[0].value,
            max: arrCurrent.sort((a, b) => {
              return Number(a.value) - Number(b.value)
            })[arrCurrent.length - 1].value,
          }
        } else {
          this.minMaxValuesCurrent = {
            min: 0,
            max: 400,
          }
        }
      }
    },
    async tabsBtn (i) {
      //按钮点击
      if (this.dialog.btnIndex == i) {
        //不能重复点击当前的按钮
        return
      }
      this.dialog.btnIndex = i
      this.$emit('update:dialog', this.dialog)
      /* await this.getMeasureProperty(
        this.dialog.ids.items[this.dialog.btnIndex]
      );
      await this.getRunningState(this.dialog.ids.items[this.dialog.btnIndex]);
      this.getItemNum(this.dialog.ids.items[this.dialog.btnIndex]); */
      this.func()
    },
    diaClose () {
      //弹窗关闭时
      /* 恢复弹窗的默认数据 */
      this.socket_ && this.socket_.close()
      this.time && clearTimeout(this.time)
      this.dialog.btnIndex = 0
      this.dialog.ids = []
      this.dialog.title = ''
      this.runningState = null
      this.tabsShow = false
      this.$emit('update:dialog', this.dialog)
      /* 恢复弹窗的默认数据 */
    },
    async getMeasuresInfo (id) {
      //通过计量点查询模板信息
      let result = await api.measure.getMeasuresInfo([id])
      if (result.success && result.data.length > 0) {
        this.getItemNum(result.data[0].template_id)
      }
    },
    async getItemNum (item) {
      //通过模板信息，查找对应的组
      let result = await api.measure.getMeasureExpressionTemplateGroups(
        item.templateId || item
      )
      if (!result.success) {
        this.$message.error(result.msg)
        return
      }
      let groupIds = []
      result.data.map((idTemp) => {
        groupIds.push(idTemp.id)
      })
      let gsResult = await api.measure.getMeasureExpressionTemplateItems2(
        JSON.stringify(groupIds)
      )
      if (!gsResult.success) {
        this.$message.error(gsResult.msg)
        return
      }
      let data = gsResult.data //组数据
      this.wsItemData = [] //轮训个数
      let index = 0
      this.newEchartsData = [] //实时数据个数
      data.map((item) => {
        if (
          !(
            item.name.indexOf('HARMONIC_VOLTAGE_A_RATIO') >= 0 ||
            item.name.indexOf('HARMONIC_VOLTAGE_B_RATIO') >= 0 ||
            item.name.indexOf('HARMONIC_VOLTAGE_C_RATIO') >= 0 ||
            item.name.indexOf('HARMONIC_CURRENT_A_RATIO') >= 0 ||
            item.name.indexOf('HARMONIC_CURRENT_B_RATIO') >= 0 ||
            item.name.indexOf('HARMONIC_CURRENT_C_RATIO') >= 0 ||
            item.pointCode == 233 ||
            item.pointCode == 601 ||
            item.name.indexOf('TOTAL_POSITIVE') >= 0 ||
            item.name.indexOf('TOTAL_REVERSE') >= 0
          )
        ) {
          //去除谐波编码和负荷率
          item.measuresId = !this.dialog.ids.items
            ? this.dialog.ids[0]
            : this.dialog.ids.items[this.dialog.btnIndex].id
          item.loading = true
          this.wsItemData.push(
            Object.defineProperty(item, 'color', {
              value: this.color[index >= this.color.length ? 0 : index],
            })
          )
          index++
          index >= this.color.length ? (index = 0) : ''
          //添加实时数值
          this.newEchartsData.push({
            label: item.displayName,
            value: '-',
          })
        }
      })
      //首先查询半小时的数据信息
      await this.getThisTimeData()
      //开启websocket推送
      this.getWcInfo()
    },
    async getThisTimeData () {
      //查询所有计量点的最近半小时的数据
      let measures = []
      this.wsItemData.map((item) => {
        measures.push({
          measureId: item.measuresId,
          pointNumber: item.pointNumber,
          pointCode: item.pointCode,
        })
        this.timeData.push([])
      })
      if (measures.length > 2) {
        await this.getElemTimeData(measures, 0, 2)
      } else {
        await this.getElemTimeData(measures)
      }
    },
    async getElemTimeData (measures, start, end) {
      if (!this.dialog.dialogVisible) {
        //如果弹窗关闭，终止请求
        return
      }
      //根据参数查询信息
      let nowDate = new Date()
      let time = nowDate.getTime() //时间戳
      let startTime = this.getTime(new Date(time - 30 * 60 * 1000))
      let endTime = this.getTime(nowDate)
      let newMeasures = Object.assign([], measures)
      if (start != undefined) {
        newMeasures = measures.slice(start, end)
      }
      newMeasures = JSON.parse(JSON.stringify(newMeasures))
      let result = await api.measuring.getMeasuringValue2(
        newMeasures,
        startTime,
        endTime,
        0,
        0
      )
      if (!result.success) {
        this.$message.error(result.msg)
      } else {
        result.data.map((item, keys) => {
          let newKeys = keys + start
          this.timeData[newKeys] = Object.assign([], item.data.data)
          this.wsItemData[newKeys] && (this.wsItemData[newKeys].loading = false)
        })
      }
      if (end && end < measures.length) {
        await this.sleep()
        await this.getElemTimeData(measures, start + 2, end + 2)
      }
    },
    getTime (nowDate) {
      //获取时间参数信息
      let year = nowDate.getFullYear()
      let month =
        nowDate.getMonth() + 1 <= 9
          ? '0' + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1
      let day =
        nowDate.getDate() <= 9 ? '0' + nowDate.getDate() : nowDate.getDate()
      let hourse =
        nowDate.getHours() <= 9 ? '0' + nowDate.getHours() : nowDate.getHours()
      let Min =
        nowDate.getMinutes() <= 9
          ? '0' + nowDate.getMinutes()
          : nowDate.getMinutes()
      let sec =
        nowDate.getSeconds() <= 9
          ? '0' + nowDate.getSeconds()
          : nowDate.getSeconds()
      let thisTime =
        year + '/' + month + '/' + day + ' ' + hourse + ':' + Min + ':' + sec
      return thisTime
    },
    async getWcInfo () {
      //获取websocket的连接信息
      let wcInfo = await api.measuringServer.allotMeasuringRealtimeNotifyServer()
      if (wcInfo.success) {
        this.wcUrl =
          window.baseConfig.wsAgreement + "://" + +
          wcInfo.data.ip +
          ':' +
          wcInfo.data.port +
          '/' +
          wcInfo.data.path //websocket地址
        let agentData = {
          //与后端约定好的验证信息
          methodCode: wsLoginState,
          key: wcInfo.data.key,
        }
        this.socket_ && this.socket_.close()
        this.socket_ = new WebSocket(this.wcUrl)
        this.socket_.onopen = () => {
          //websocket打开时触发，发送验证信息进行登陆
          this.sendMsg(agentData)
        }
        this.socket_.onmessage = (e) => {
          //websocket接收到信息时触发
          this.webSocketMsg(JSON.parse(e.data))
        }
        this.socket_.onclose = (e) => {
          //websocket连接关闭时触发
          console.log('websocket已关闭')
        }
        this.socket_.onerror = () => {
          //websocket连接错误时
          console.log('WebSocket连接发生错误')
        }
      }
    },
    sendMsg (obj) {
      //websocket推送数据到后端
      this.socket_.send(JSON.stringify(obj))
    },
    webSocketMsg (e) {
      if (e.methodCode == wsRegisterNode) {
        //todo登录成功后向监测数据实时推送服务器注册订阅计量点
        let ids = []
        this.wsItemData.map((item) => {
          let tempItemId = ids.find((i) => i.id === item.measuresId)
          if (!tempItemId) {
            ids.push({
              id: item.measuresId,
              points: [{ code: item.pointCode, number: item.pointNumber }],
            })
          } else {
            tempItemId.points.push({
              code: item.pointCode,
              number: item.pointNumber,
            })
          }
        })
        let agentData = {
          methodCode: wsSetNodeSucc,
          measures: ids,
        }
        this.sendMsg(agentData)
      }
      if (e.methodCode == wsSuccState) {
        console.log('计量点注册成功')
      }
      if (e.methodCode == wsMsgSatet) {
        //获取到推送的数据
        this.websocketData = e //websocket返回过来的数据
      }
    },
    async sleep () {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve()
        }, 500)
      })
    },
    async updateData (data) {
      for (let i in data) {
        let temp = this.newEchartsData.find((item) => item.label === i) //判断之前有没有添加过
        if (temp) {
          //如果有，更新数值即可
          temp.value = data[i]
        } else {
          this.newEchartsData.push({
            label: i,
            value: data[i],
          })
        }
      }
    },
  },
  destroyed () {
    this.time && clearTimeout(this.time)
  },
  watch: {
    dialog: {
      //弹窗数据变化时
      handler (newVal, oldVal) {
        this.$nextTick(() => {
          this.func()
        })
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style lang='scss' scoped>
.winDialog {
  /* 弹窗 */
  .exhibition-dialog {
    display: flex;
    flex-flow: column;
    justify-content: center;
    ::v-deep .el-dialog {
      border-radius: 4px;
      overflow: hidden;
    }
    ::v-deep .el-dialog__header {
      height: 36px;
      box-sizing: border-box;
      padding: 0 10px;
      .el-dialog__title {
        color: #fff;
        font-weight: bold;
        line-height: 36px;
      }
      .el-dialog__headerbtn {
        top: 10px;
        .el-dialog__close {
          color: #fff;
        }
      }
    }
    ::v-deep .el-dialog__body {
      background: #d5dadd;
      padding: 0;
      flex: 1;
    }
    .dialog {
      height: 600px;
      padding: 15px 15px 7px;
      box-sizing: border-box;
      overflow: auto;
      .title {
        font-weight: bold;
        color: #2e3842;
        height: 30px;
        line-height: 30px;
        background: #f0f3f4;
        padding: 0px 10px;
        box-sizing: border-box;
        text-align: left;
      }
      .tabs {
        width: 100%;
        height: 40px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        padding: 0 5px;
        box-sizing: border-box;
        overflow-x: auto;
        margin-bottom: 8px;
        ::v-deep .el-button + .el-button {
          margin-left: 5px;
        }
      }
      .header1 {
        height: 290px;
        display: flex;
        .header-list {
          width: 100%;
          height: 100%;
          display: flex;
          margin-right: 8px;
          .header-item {
            width: 100%;
            border-radius: 4px;
            overflow: hidden;
          }
          .item {
            //margin-top: 8px;
          }
        }
        .header-list:last-child {
          margin-right: 0;
        }
        .second,
        .thrid {
          flex: 3;
        }
      }
      .alarmInfo {
        .header-list {
          /*flex: 1;*/
        }
      }
      .void {
        margin-top: 10px;
      }
      .line-list {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        margin-top: 8px;
        justify-content: space-between;
        .line-item {
          width: calc(25% - 5px);
          height: 330px;
          box-sizing: border-box;
          margin-right: 5px;
          margin-bottom: 5px;
          overflow: hidden;
          &:nth-child(4n) {
            margin-right: 0;
          }
          border-radius: 4px 4px 0 0;
          .box {
            width: 100%;
            height: 100%;
            background: #fff;
          }
        }
      }
    }
  }
  /* 弹窗 */
}
</style>
<style scoped>
</style>